import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { IllustratedMessage } from '@percent/lemonade'
import { useAuthDispatch } from '@percent/partner-dashboard/common/hooks'
import { SET_LOGOUT } from '@percent/partner-dashboard/context/auth'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export function NoPrivilegeAccessView() {
  const { t } = useTranslation()
  const dispatch = useAuthDispatch()
  const { authService } = useServices()

  const handleLogout = useCallback(() => {
    authService.logout().then(() => {
      localStorage.removeItem('authState')
      dispatch({
        type: SET_LOGOUT
      })
    })
  }, [authService, dispatch])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <IllustratedMessage
        illustration="no-access"
        title={t('typography.noPrivilegeAccess')}
        description={t('typography.noPrivilegeAccessDescription')}
        cta={{
          label: t('button.signOut'),
          onClick: handleLogout
        }}
      />
    </div>
  )
}
